import { type PropsWithChildren } from 'react';
import { useParams } from 'react-router-dom';

import { useAppSelector } from '@verantos-dev/app-state-base';
import { selectCohortDefinitionError } from '@verantos-dev/app-state-cohort-definition';
import { useGetStudyArmQuery } from '@verantos-dev/data-access-cohorts';
import { DialogMessageBox } from '@verantos-dev/shared-components';

import { StyledPageTabContent } from './StyledPageTabContent';
import { ErrorWithRetryButtonCard } from '../../../../components/ErrorWithRetryButtonCard/ErrorWithRetryButtonCard';

export const PageTabContent = ({ children }: PropsWithChildren) => {
  const error = useAppSelector(selectCohortDefinitionError);
  const { projectId, cohortId } = useParams();
  const { refetch } = useGetStudyArmQuery(
    {
      projectId: projectId || '',
      studyArmId: cohortId || '',
    },
    {
      skip: true,
    }
  );

  if (error) {
    return (
      <StyledPageTabContent>
        <DialogMessageBox
          id="loading-error-message-box"
          title="There was an error loading simple events."
          type="error"
          text={
            <ErrorWithRetryButtonCard
              message="Please refresh the page or try again later."
              onRetry={refetch}
            />
          }
        />
      </StyledPageTabContent>
    );
  }

  return projectId && cohortId && <StyledPageTabContent>{children}</StyledPageTabContent>;
};
